module.exports = __webpack_public_path__ + "img/new-cod.255c49a4.svg";